<template>
  <v-app style="background: #F5F8FD;">
    <transition mode="out-in" :name="transitionName">
      <router-view />
    </transition>
    <Loading />
    <v-snackbar
      :value="snack"
    >
      {{ msg }}
      <v-btn
        color="blue"
        flat
      >
        Fechar
      </v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import Loading from '@/components/common/Loading'

export default {
  data () {
    return {
      transitionName: 'page'
    }
  },
  watch: {
    $route(to, from) {
      this.transitionName = (from.path.indexOf('dashboard') > -1) && to.path == '/Logout' ? 'log-out' : 'page'
    }
  },
  beforeRouteEnter (to, from, next) {
    // const toDepth = to.path.split('/').length
    // const fromDepth = from.path.split('/').length
    // debugger
    // console.log(to.path, 'beforeRouteUpdate to a')
    // console.log(from.path, 'beforeRouteUpdate from a')
    this.transitionName = to.path.charIndex('Logout') > -1 ? 'page' : 'log-out'
    next()
  },
  components: { Loading },
  computed: {
    snack(){
      return this.$store.state.error
    },
    msg(){
      return this.$store.state.errorMsg
    }
  },
  mounted(){
    this.$i18n.locale = localStorage.language
  }
}
</script>

<style>
  *, *::before, *::after{
    font-family: 'Open Sans', sans-serif;
  }

  /* #welcome {
    transition: transform .2s;
  } */

  .page-enter-active, .page-leave-active {
    /* transition: all .1s; */
    transition: opacity 0.2s ease-in-out, transform 0.2s ease-in-out;
    /* transition-delay: .5s; */
  }
  .page-enter, .page-leave-to /* .list-leave-active below version 2.1.8 */ {
    opacity: 0;
     /* transform: translateX(15%); */
     /* transform: translateY(-15%); */
    /* transform: scale(50%, 50%); */
    /* transition: all .5s; */
    /* transform-origin: bottom left; */
    /* transition-delay: .5s; */
  }

  .log-out-enter-active, .log-out-leave-active {
    /* transition: all .1s; */
    transition: opacity .2s ease-in-out, transform .2s ease-in-out;
    /* transition-delay: .5s; */
  }
  .log-out-enter, .log-out-leave-to /* .list-leave-active below version 2.1.8 */ {
    opacity: 0;
    /* transform: scale(0.3); */
    /* transform: translateY(15%); */
    /* transform: scale(50%, 50%); */
    /* transition: all .5s; */
    /* transform-origin: bottom left; */
    /* transition-delay: .5s; */
  }

  iframe{
    border: 0;
    width: 100%;
    height: 100%;
  }

  .v-messages{
    min-height: 14px;
  }
</style>
